$(function () {
  console.log("Ganpati Bappa Morya!!!");
  let winWT = $(window).innerWidth();
  let header = $("header");
  let previousScroll = 0;
  let headerHT = header.innerHeight();
  gsap.registerPlugin(ScrollTrigger);

  // Store ScrollTrigger instances for pinned sections
  let glanceST = null;
  let awardsST = null;

  /******************************************************************************/

  $("#header").load("header.html", function () {
    previousScroll = 0;
    headerHT = header.innerHeight();

    // Reset menuTl so stale tweens from previous load don't stack
    menuTl = gsap.timeline();

    gsap.set("header .nav-hld", { opacity: 0, y: 50 });
    addHoverCursorClass();
    //bannerScreenAim();
  });

  $("#footer").load("footer.html", function () {
    // footer loaded
  });

  /******************************************************************************/

  var lenis;
  var lenisTicker;

  function reconnectLenis() {
    if (typeof Lenis === "undefined") {
      console.warn("Lenis library is not loaded");
      return;
    }
    if (lenis) {
      if (lenisTicker) {
        gsap.ticker.remove(lenisTicker);
        lenisTicker = null;
      }
      lenis.destroy();
      lenis = null;
    }
    try {
      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(1.5, -10 * t)),
        orientation: "vertical",
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        infinite: false,
      });

      lenis.on("scroll", ScrollTrigger.update);

      lenisTicker = function (time) {
        if (lenis) lenis.raf(time * 1000);
      };

      gsap.ticker.add(lenisTicker);
      gsap.ticker.lagSmoothing(0);

      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 50);
    } catch (error) {
      console.error("Error initializing Lenis:", error);
    }
  }

  reconnectLenis();

  setTimeout(function () {
    if (lenis) lenis.resize();
    ScrollTrigger.refresh();
    requestAnimationFrame(function () {
      ScrollTrigger.update();
    });
  }, 500);

  $(document).on( "shown.bs.tab", 'button[data-bs-toggle="tab"], a[data-bs-toggle="tab"]',
    function () {
      ScrollTrigger.refresh();
      if (lenis) {
        setTimeout(function () {
          lenis.resize();
          ScrollTrigger.refresh();
        }, 100);
      }
    },
  );

  /******************************************************************************/

  wow = new WOW({ offset: 150 });
  wow.init();

  /******************************************************************************/

  let menuTl = gsap.timeline();

  // Helper: wait for async-loaded header elements to exist in DOM
  function waitForHeader(cb) {
    if ($("header nav").length && $("header .nav-hld").length) {
      cb();
    } else {
      setTimeout(() => waitForHeader(cb), 50);
    }
  }

  // Delegated click — works even though .nav-icon is inside async header.html
  $(document).on("click", ".nav-icon", function () {
    if (!$("header nav").length || !$("header .nav-hld").length) return;

    if ($(this).hasClass("open")) {
      resetMobileMenu();
    } else {
      $(this).addClass("open");

      // zero-duration gsap.to instead of gsap.set — supports onComplete
      gsap.to("header nav", {
        duration: 0,
        display: "block",
        onComplete: function () {
          $("body").css({ overflowY: "hidden" });
          gsap.set("header nav", { pointerEvents: "auto" });
          menuTl.to("header nav .bg-overlay span", { duration: 0.3, height: "100%", stagger: 0.05, })
                .to("header .nav-hld", { duration: 0.3, opacity: 1, y: 0 }, "-=0.05",);
        },
      });
    }
  });

  // Delegated click for overlay — also inside async header.html
  $(document).on("click", "header .overlay", function () {
    resetMobileMenu();
  });

  function resetMobileMenu() {
    if (!$("header nav").length || !$("header .nav-hld").length) return;

    $(".nav-icon").removeClass("open");
    menuTl
      .to("header .nav-hld", { duration: 0.3, opacity: 0, y: 50 })
      .to("header nav .bg-overlay span", {
        duration: 0.3,
        height: 0,
        stagger: -0.05,
        onComplete: function () {
          gsap.set("header nav", { pointerEvents: "none" });
          $("body").css({ overflowY: "auto" });
          // ✅ Reset menuTl after close so next open starts fresh
          menuTl = gsap.timeline();
        },
      });
  }

  function setHeaderOnScroll() {
    winWT = $(window).innerWidth();
    if (winWT > 1100) {
      if ($(this).scrollTop() > 120) {
        $("header").addClass("sticky");
      } else {
        $("header").removeClass("sticky");
      }
    }
  }
  setHeaderOnScroll();

  function setHeaderAnim() {
    winWT = $(window).innerWidth();
    if (winWT >= 1024) {
      const currentScroll = $(this).scrollTop();
      if (currentScroll > previousScroll) {
        header.css("top", -(headerHT + 18) + "px");
      } else {
        header.css("top", "0");
      }
      previousScroll = currentScroll;
    }
  }

  $(window).on("scroll", function () {
    setHeaderAnim();
    setHeaderOnScroll();
    updateHexagonRotation();
  });

  $(window).on("resize", function () {
    setHeaderOnScroll();
    pinScrollGlanceSect();
    updateHexagonRotation();
    pinScrollAwardsSect();
    if (parallaxInitialized) {
			setTimeout(function(){
				parallaxBanner();
			}, 500); 
		}
    //revealBannerImage();
  });

  /******************************************************************************/

  /* Cursor */
  const cursor = document.getElementById("cursor");
  const ring = document.getElementById("cursorRing");
  let mouseX = 0,
    mouseY = 0,
    ringX = 0,
    ringY = 0;

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    gsap.set(cursor, { x: mouseX, y: mouseY });
  });

  gsap.ticker.add(() => {
    ringX += (mouseX - ringX) * 0.12;
    ringY += (mouseY - ringY) * 0.12;
    gsap.set(ring, { x: ringX, y: ringY });
  });

  function addHoverCursorClass() {
    $("a").each(function () {
      $(this).on("mouseenter", function () {
        $(cursor).addClass("hover");
        $(ring).addClass("hover");
      });
      $(this).on("mouseleave", function () {
        $(cursor).removeClass("hover");
        $(ring).removeClass("hover");
      });
    });

    $(".swiper-button-next, .swiper-button-prev").each(function () {
      $(this).on("mouseenter", function () {
        $(cursor).addClass("hover");
      });
      $(this).on("mouseleave", function () {
        $(cursor).removeClass("hover");
      });
    });
  }
  addHoverCursorClass();

  $('.slide-controller-con').on({
    mouseenter: function(){
      $('.cursor-ring').css({opacity : 0});
    },
    mouseleave: function(){
      $('.cursor-ring').css({opacity : 1});
    }
  });
  

  /******************************************************************************/

  function initCounter() {
    //console.log('init');
    document.querySelectorAll(".odometer").forEach((el) => {
      const value = parseFloat(el.dataset.count);

      // Destroy previous Odometer instance if it exists
      if (el._odometerInstance) {
        el._odometerInstance.update(0);
      }

      // Reset the displayed value to 0 first
      el.innerHTML = '0';

      const odometer = new Odometer({ el: el, value: 0 });
      el._odometerInstance = odometer;

      let hasRun = false;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !hasRun) {
              odometer.update(value);
              hasRun = true;
              observer.disconnect(); // clean up after firing
            }
          });
        },
        { threshold: [0, 0.9] },
      );

      observer.observe(el);
    });
  }

  initCounter();

  /******************************************************************************/ 
  let parallaxInitialized = false;
  function parallaxBanner(){ 
		// Prevent multiple initializations
		if (parallaxInitialized) {
			// Kill existing ScrollTriggers before recreating
			ScrollTrigger.getAll().forEach(trigger => {
				if (trigger.vars.trigger && trigger.vars.trigger.classList.contains('parallax-banner')) {
					trigger.kill();
				}
			});
		} 
		gsap.utils.toArray(".parallax-banner").forEach(function(container) {
		let image = container.querySelector("img");
		
		// Set initial state using CSS to prevent any GSAP conflicts
		image.style.transform = 'translateY(-30%) scale(1.5)';
		image.style.transformOrigin = 'center center';
		
		// Function to set up the animation once image is loaded
		function setupParallax() {
			// Clear the CSS transform and let GSAP take over
			image.style.transform = '';
			
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: container,
					scrub: true,
					pin: false,
				},
				}); 
				tl.fromTo(image, {
					yPercent: -30,
					scale: 1.3
				}, {
					yPercent: 30, 
					scale: 1,
					ease: "none",
				}); 
		}
		
		// Check if image is already loaded
		if (image.complete && image.naturalHeight !== 0) {
			setupParallax();
		} else {
			// Wait for image to load
			image.addEventListener('load', setupParallax);
			// Fallback in case load event doesn't fire
			image.addEventListener('error', setupParallax);
		}
		});
		
		parallaxInitialized = true;
	}
	
	// Wait for window to fully load before setting up parallax
	window.addEventListener('load', function() {
		parallaxBanner();  
	}); 

  /******************************************************************************/

  let bannerScreenAim = () => {
    let bannerVideo = $('#banner').find('video')[0];
    if (!bannerVideo) return; // guard: exit if not on banner page

    // Reset states before animating (needed on barba re-entry)
    gsap.set('header', { opacity: 0 });
    gsap.set('#banner h1', { opacity: 0, y: 100 });
    gsap.set('#banner .report-tl', { opacity: 0, y: 100 });
    gsap.set('#banner video', { opacity: 0 });

    let tl_Banner = gsap.timeline();
    tl_Banner.to('#banner video', {
                duration: 0.6, opacity: 1,
                onComplete: function () { 
                  console.log('asdad');
                  $('#banner').find('video')[0].play(); 
                }
              }, 'b-anim')
            .to('header', { duration: 1.5, opacity: 1, y: 0 }, 'b-anim-=0.2')
            .to('#banner h1', { duration: 1, opacity: 1, y: 0 }, 'b-anim+=0.4')
            .to('#banner .report-tl', { duration: 1.5, opacity: 1, y: 0 }, 'b-anim+=0.5');
  }

 // bannerScreenAim();
  /* $(window).on('load', function(){ 
    bannerScreenAim();
  }); */


  /******************************************************************************/

  function initSliders() {
    // Progress detail slider + banner slider (controlled pair)
    if ($(".progress-det-slider").length > 0) {
      var swiperOrgSnapshotProgressSlider = new Swiper(".progress-det-slider", {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 600,
        pagination: {
          el: ".progress-det-slider .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".progress-det-slider .swiper-button-next",
          prevEl: ".progress-det-slider .swiper-button-prev",
        },
      });

      swiperOrgSnapshotProgressSlider.on(
        "slideChange afterInit init",
        function () {
          let currentSlide = "0" + (this.activeIndex + 1);
          $(".counter").empty().append(currentSlide);
        },
      );

      var swiperProgressBannerSlider = new Swiper(".progress-banner-slider", {
        spaceBetween: 0,
        effect: "fade",
        slidesPerView: 1,
        speed: 600,
      });

      swiperOrgSnapshotProgressSlider.controller.control = swiperProgressBannerSlider;
    }

    // Segment review slider
    if ($(".segment-con").length > 0) {
      new Swiper(".segment-con", {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 600,
        navigation: {
          nextEl: ".segment-con .swiper-button-next",
          prevEl: ".segment-con .swiper-button-prev",
        },
      });
    }

    // Glance slider
    if ($(".glance-slider-hld").length > 0) {
      new Swiper(".glance-slider-hld", {
        spaceBetween: 20,
        slidesPerView: 1,
        speed: 600,
        navigation: {
          nextEl: ".at-a-glance .swiper-button-next",
          prevEl: ".at-a-glance .swiper-button-prev",
        },
        breakpoints: {
          320: { slidesPerView: 1, autoHeight: true },
          575: { slidesPerView: 1.1, autoHeight: true },
          1023: { slidesPerView: 1 },
        },
      });
    }

    // BOD Directors slider
    if ($(".bod-panel").length > 0) {
      new Swiper(".bod-panel", {
        spaceBetween: 20,
        slidesPerView: 3,
        speed: 600,
        navigation: {
          nextEl: ".bod-panel .swiper-button-next",
          prevEl: ".bod-panel .swiper-button-prev",
        },
        breakpoints: {
          320: { slidesPerView: 1 },
          575: { slidesPerView: 2 },
          1023: { slidesPerView: 3 },
        },
      });
    }

    // Capital sliders (controlled pair)
    if ($(".capital-det-slider").length > 0) {

      let swiperCapitalDetSlider = null;
      const isDesktop = window.innerWidth > 1023;
      if (swiperCapitalDetSlider) {
        swiperCapitalDetSlider.destroy(true, true);
        swiperCapitalDetSlider = null;
      }

      var swiperCapitalBannerSlider = new Swiper(".capital-banners", {
        spaceBetween: 0,
        slidesPerView: 1,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        speed: 600, 
      });

      swiperCapitalDetSlider = new Swiper(".capital-det-slider", {
        spaceBetween: 10,
        slidesPerView: 1,
        speed: 600,
        effect: isDesktop ? "fade" : "slide",
        fadeEffect: { crossFade: isDesktop },
        navigation: {
          nextEl: ".capitals .swiper-button-next",
          prevEl: ".capitals .swiper-button-prev",
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            resetAnimStorySlider(activeIndex);
            initCounter();
          },
          slideChangeTransitionStart: function () {
            const activeIndex = this.activeIndex;
            resetAnimStorySlider(activeIndex);
            initCounter();
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = this.activeIndex;
            animStorySlider(activeIndex);
          },
          resize: function () {
            const activeIndex = this.activeIndex;
            resetAnimStorySlider(activeIndex);
            animStorySlider(activeIndex);
            initCounter();
          },
        },
      });

      swiperCapitalDetSlider.controller.control = swiperCapitalBannerSlider;

      function animStorySlider(slideIndex){  
        let currentSlide = $('.capital-det-slider .swiper-slide').eq(slideIndex);  
        let currentTitle = currentSlide.find('.sect-tl'); 
        let currentDesc = currentSlide.find('.cap-desc');
        let currentCapitalDetPanel = currentSlide.find('.capital-det-panel'); 
        let tlCapitalAnim = gsap.timeline();
        tlCapitalAnim.to(currentSlide, { duration: 0.1, opacity:1, ease: "power2.out"})
                     .to(currentTitle, { duration: 0.7, opacity:1, y:0, ease: "power2.out"}) 
                     .to(currentDesc, { duration: 0.7, opacity:1, y:0, ease: "power2.out"}, '-=0.5')
                     .to(currentCapitalDetPanel, { duration: 0.7, opacity:1, y:0, ease: "power2.out"}, '-=0.5')
      }

      function resetAnimStorySlider(slideIndex){ 
        let currentSlide = $('.capital-det-slider .swiper-slide').eq(slideIndex);  
        let currentTitle = currentSlide.find('.sect-tl'); 
        let currentDesc = currentSlide.find('.cap-desc');
        let currentCapitalDetPanel = currentSlide.find('.capital-det-panel'); 
        let tlCapitalAnim = gsap.timeline();
        tlCapitalAnim.set(currentSlide, { duration: 0.1, opacity:0})
        tlCapitalAnim.set(currentTitle, { duration: 0.1, opacity:0, y:40})
        tlCapitalAnim.set(currentDesc, { duration: 0.1, opacity:0, y:60}) 
        tlCapitalAnim.set(currentCapitalDetPanel, { duration: 0.1, opacity:0, y:60})
      }

    }

    // Awards slider
    if ($(".awards-rec-slider-hld").length > 0) {
      new Swiper(".awards-rec-slider-hld", {
        spaceBetween: 0,
        slidesPerView: 1,
        speed: 600,
        navigation: {
          nextEl: ".awards-rec-slider-hld .swiper-button-next",
          prevEl: ".awards-rec-slider-hld .swiper-button-prev",
        },
        breakpoints: {
          320: { slidesPerView: 1, autoHeight: true },
          575: { slidesPerView: 1.1, autoHeight: true },
          1023: { slidesPerView: 1 },
        },
      });
    }
  }

  initSliders();

  /******************************************************************************/

  function pinScrollGlanceSect() {
    winWT = $(window).innerWidth();
    let horizontalSection = document.querySelector(
      ".at-a-glance .scroll-panel",
    );
    let container = document.querySelector(".at-a-glance .container");
    if (!horizontalSection || !container) return;

    if (glanceST) {
      glanceST.kill();
      glanceST = null;
      gsap.set(horizontalSection, { x: 0, clearProps: "x" });
    }

    if (winWT > 1023) {
      glanceST = gsap.to(horizontalSection, {
        x: () => -(horizontalSection.scrollWidth - container.offsetWidth),
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "top top+=20",
          end: () =>
            "+=" + (horizontalSection.scrollWidth - container.offsetWidth),
          pin: container,
          pinSpacing: true,
          scrub: 1,
          invalidateOnRefresh: true,
          onRefresh: (self) => {
            self.vars.end = () =>
              "+=" + (horizontalSection.scrollWidth - container.offsetWidth);
          },
        },
      }).scrollTrigger;
    }
  }

  pinScrollGlanceSect();

  /******************************************************************************/

  function pinScrollAwardsSect() {
    winWT = $(window).innerWidth();
    let horizontalSection = document.querySelector(
      ".awards-recognitions .scroll-panel",
    );
    let container = document.querySelector(".awards-recognitions .container");
    if (!horizontalSection || !container) return;

    if (awardsST) {
      awardsST.kill();
      awardsST = null;
      gsap.set(horizontalSection, { x: 0, clearProps: "x" });
    }

    if (winWT > 1023) {
      awardsST = gsap.to(horizontalSection, {
        x: () => -(horizontalSection.scrollWidth - container.offsetWidth),
        ease: "none",
        scrollTrigger: {
          trigger: ".awards-recognitions .container",
          start: "top top+=20",
          end: () =>
            "+=" + (horizontalSection.scrollWidth - container.offsetWidth),
          pin: ".awards-recognitions",
          pinSpacing: true,
          scrub: 1,
          invalidateOnRefresh: true,
          onRefresh: (self) => {
            self.vars.end = () =>
              "+=" + (horizontalSection.scrollWidth - container.offsetWidth);
          },
        },
      }).scrollTrigger;
    }
  }

  pinScrollAwardsSect();

  /******************************************************************************/

  function updateHexagonRotation() {
    const $orgDet = $(".org-det");
    const $hexagon = $(".org-det .hexagon");
    if (!$orgDet.length || !$hexagon.length) return;

    const orgDetEl = $orgDet[0];
    const rect = orgDetEl.getBoundingClientRect();
    const sectionHeight = rect.height;
    if (sectionHeight <= 0) return;

    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const progress = gsap.utils.clamp(
      0,
      1,
      (viewportHeight - rect.top) / (sectionHeight + viewportHeight),
    );

    const rotation = progress * sectionHeight * 0.2;
    gsap.set($hexagon, {
      rotation: rotation,
      transformOrigin: "50% 50%",
      overwrite: true,
    });
  }

  updateHexagonRotation();

  /******************************************************************************/

  function animIntroText() {
    let bannerH2 = document.querySelector(".org-snapshot .sect-tl p");
    if (!bannerH2) return;

    let split = new SplitText(bannerH2, { type: "words" });
    let words = split.words;

    gsap.set(words, { opacity: 0 });

    ScrollTrigger.create({
      trigger: ".org-snapshot",
      start: "top 70%",
      end: "bottom 100%",
      once: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const totalWords = words.length;

        words.forEach((word, index) => {
          const wordProgress = index / totalWords;
          const nextWordProgress = (index + 1) / totalWords;

          let opacity = 0;
          if (progress >= nextWordProgress) {
            opacity = 1;
          } else if (progress >= wordProgress) {
            const fadeProgress =
              (progress - wordProgress) / (nextWordProgress - wordProgress);
            opacity = fadeProgress;
          }

          gsap.to(word, { opacity: opacity, duration: 0.01, overwrite: false });
        });
      },
    }); 
  }

  animIntroText(); 

  /******************************************************************************/

  function animSectionTitle() {
    document.querySelectorAll(".sect-tl").forEach((section) => {
      const title = section.querySelector("h2");
      if (!title) return;

      const split = new SplitText(title, { type: "words" });
      const words = split.words;

      gsap.set(words, { opacity: 0, y: 50 });

      gsap.to(words, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 80%",
          once: true,
        },
      });
    });
  }

  animSectionTitle();

  /******************************************************************************/

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.stop();  // or .pause()
        }
      });
    },
    { threshold: 0.3 }
  );

  customElements.whenDefined('lottie-player').then(() => {
    document.querySelectorAll('.lottie-scroll').forEach(player => {
      observer.observe(player);
    });
  });

  /******************************************************************************/ 

  function reinitPageFunctions() {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
      lenis.resize();
    }

    previousScroll = 0;

    wow = new WOW({ offset: 150 });
    wow.init();

    initCounter();
    initSliders();

    if (glanceST) {
      glanceST.kill();
      glanceST = null;
    }
    if (awardsST) {
      awardsST.kill();
      awardsST = null;
    }

    setTimeout(function () {
      bannerScreenAim(); 
    }, 500);
    pinScrollGlanceSect();
    pinScrollAwardsSect();
    updateHexagonRotation();
    animIntroText();
    animSectionTitle();
    addHoverCursorClass();

    setTimeout(function () {
      ScrollTrigger.refresh(true);
    }, 100);
  }

  /******************************************************************************/

  let barbaPageTransition = function () {
    function pageTransition() {
      let tl = gsap.timeline();
      tl.to(".transition", {
        duration: 1,
        scaleY: 1,
        transformOrigin: "bottom",
        ease: "Expo.easeInOut",
      });
      tl.to(".transition", {
        duration: 1,
        scaleY: 0,
        transformOrigin: "top",
        ease: "Expo.easeInOut",
        delay: 0.2,
      });
    }
    

    function delay(n) {
      n = n || 0;
      return new Promise((done) => {
        setTimeout(() => done(), n);
      });
    }

    function updateActiveLink(namespace) {
      let $links = $("#header").find("a[href]");
      $links.removeClass("active");

      let targetHref = namespace.endsWith(".html")
        ? namespace
        : namespace + ".html";

      let $activeLink = $links.filter(function () {
        let linkHref = $(this).attr("href");
        return linkHref === targetHref || linkHref === "/" + targetHref;
      });

      if ($activeLink.length > 0) $activeLink.first().addClass("active");
    }

    function initActiveLinkOnLoad() {
      const container = document.querySelector('[data-barba="container"]');
      if (container && container.dataset.barbaNamespace) {
        updateActiveLink(container.dataset.barbaNamespace);
      }
    }
    setTimeout(initActiveLinkOnLoad, 100);

    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    barba.hooks.leave(() => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      glanceST = null;
      awardsST = null;
      reconnectLenis();
    });

    barba.hooks.beforeEnter(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (lenis) lenis.scrollTo(0, { immediate: true });
    });

    barba.hooks.afterEnter((data) => {
      window.scrollTo(0, 0);
      if (lenis) lenis.scrollTo(0, { immediate: true });

      updateActiveLink(data.next.namespace);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          reinitPageFunctions();
        });
      });
    });

    barba.init({
      sync: true,
      transitions: [
        {
          async leave(data) {
            const done = this.async();
            pageTransition();
            await delay(1000);
            done();
          },

          async enter(data) {
            waitForHeader(() => resetMobileMenu());
          },

          async once(data) {
            window.scrollTo(0, 0);
            waitForHeader(() => resetMobileMenu());

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                reinitPageFunctions();
              });
            });
          },
        },
      ],
    });
  };

  barbaPageTransition();
});
